import {IFormFilesInterface} from "../Shared/form-files.interface";

export type IDisabledVetSixthSection = {
    AwardVerificationLetter?: Array<IFormFilesInterface>,
}

export const DisabledVetSixthSectionInterface = (): IDisabledVetSixthSection => ({
    AwardVerificationLetter: undefined
})